import { useState, useRef } from "react";
import { Table, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import InvestigationForm from "./InvestigationForm";
import { formatToINR } from "../../../helpers/utility";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import styles from "./Investigations.module.css";
import useIsMobile from "../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../hooks/usePageFillTableScroll";

const { Paragraph } = Typography;

const InvestigationsTable = ({ data, refreshPage, userDetails, loading }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [editListData, setEditListData] = useState(null);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );

  const columns = [
    {
      title: "Investigation",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (value) =>
        value ? (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "more",
            }}
            style={{ marginBottom: 0 }}
          >
            {value}
          </Paragraph>
        ) : (
          "-"
        ),
    },
    {
      title: "Cash Price",
      dataIndex: "cash_price",
      key: "cash_price",
      sorter: (a, b) => a?.cash_price - b?.cash_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    {
      title: "Insurance Price",
      dataIndex: "insurance_price",
      key: "insurance_price",
      sorter: (a, b) => a?.insurance_price - b?.insurance_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    ...(defaultRole === "Facility_Admin"
      ? []
      : [
          {
            title: "",
            key: "action",
            width: 48,
            className: styles.actionCell,
            render: (_, record) => (
              <EditOutlined
                className={styles.editIcon}
                onClick={() => {
                  setIsVisible(true);
                  setEditListData(record);
                }}
              />
            ),
          },
        ]),
  ];

  return (
    <>
      <div ref={tableWrapRef} className={`${styles.tableWrap} ui-table-fill-body`}>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered={false}
          rowKey="id"
          scroll={tableScroll}
        />
      </div>
      {isVisible && (
        <InvestigationForm
          open={isVisible}
          setOpen={setIsVisible}
          refreshPage={refreshPage}
          editListData={editListData}
        />
      )}
    </>
  );
};

export default InvestigationsTable;
